/* eslint-disable import/prefer-default-export */
import { API_URL } from '../../../../utils/config';

export const GET_REFERRAL_REQUEST_URL = `${API_URL}/referral/getReferrals`;
export const GET_REFERRAL_SEARCH_URL = `${API_URL}/referral/searchreferrals`;
export const EDIT_REFERRAL_REQUEST_URL = `${API_URL}/referral/referralstatus`;
